export default __webpack_public_path__ + "static/media/SearchIcon_Header.309a4349.svg";